module.exports = __webpack_public_path__ + "img/envelope6.bbaa53e7.jpg";